import React, { useState, useEffect, useRef } from 'react';
import { THINKING_STATES } from '../thinkingStates';

// Inject keyframes once — self-contained, no global CSS dependency
let injected = false;
function injectKeyframes() {
  if (injected || document.getElementById('athena-thinking-kf')) return;
  injected = true;
  const s = document.createElement('style');
  s.id = 'athena-thinking-kf';
  s.textContent = `
    @keyframes thinkFade {
      from { opacity: 0; transform: translateY(3px); }
      to   { opacity: 1; transform: translateY(0);   }
    }
    @keyframes thinkDot {
      0%, 80%, 100% { opacity: 0.25; }
      40%           { opacity: 1;    }
    }
  `;
  document.head.appendChild(s);
}

export function ThinkingIndicator({ type, messages: msgsProp }) {
  const [idx, setIdx] = useState(0);
  const timerRef = useRef(null);

  const states = msgsProp || THINKING_STATES[type] || THINKING_STATES.CONVERSA;

  useEffect(() => {
    injectKeyframes();
  }, []);

  useEffect(() => {
    setIdx(0);
    if (states.length <= 1) return;
    // Advance through each step once — stop at last, never loop
    const timer = setInterval(() => {
      setIdx(i => {
        const next = i + 1;
        if (next >= states.length - 1) {
          clearInterval(timer);
          return states.length - 1;
        }
        return next;
      });
    }, 2200);
    timerRef.current = timer;
    return () => clearInterval(timer);
  }, [type, states.length]);

  return (
    <div style={{
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 10,
      maxWidth: 740,
      width: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
    }}>
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.07)',
        borderRadius: 20,
        padding: '7px 16px',
        animation: 'thinkFade .25s ease',
      }}>
        <span style={{
          fontSize: 12.5,
          color: 'rgba(160,175,230,0.8)',
          letterSpacing: '.01em',
        }}>
          {states[idx]}
        </span>
        <span style={{ display: 'inline-flex', gap: 3, alignItems: 'center' }}>
          {[0, 0.25, 0.5].map((delay, i) => (
            <span key={i} style={{
              width: 4,
              height: 4,
              borderRadius: '50%',
              background: 'rgba(120,140,220,0.7)',
              display: 'inline-block',
              animation: `thinkDot 1.4s ease ${delay}s infinite`,
            }} />
          ))}
        </span>
      </div>
    </div>
  );
}
